import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Section8 = ({url}) => {

const [active, setActive] = useState(null);

const faqs = [
  {
    q: "How long does it take to implement InteliHire?",
    a: "Most organizations are up and running within 48–72 hours. Our team handles the setup, and your HR staff can start posting jobs and screening candidates immediately, with no lengthy training required.",
  },
  {
    q: "Will InteliHire integrate with our existing HR systems?",
    a: "Yes. InteliHire seamlessly integrates with Google Calendar for scheduling and can connect with most ATS and HRIS platforms.",
  },
  {
    q: "Is our candidate data secure and compliant?",
    a: "Yes. InteliHire is built with enterprise-grade security standards and complies with data protection regulations including GDPR.",
  },
  {
    q: "How does pricing work for InteliHire?",
    a: "Pricing is based on your hiring volume and organizational needs. Contact us for a custom quote tailored to your requirements—we'll show you the ROI before you commit.",
  },
  {
    q: "How does InteliHire handle large volumes of applicants?",
    a: "InteliHire is built for scale. Whether you receive 50 or 5,000 applications, our AI recruiting software processes them instantly—ranking, matching, and shortlisting candidates in minutes.",
  },
  {
    q: "Can I invite my team to use your AI recruitment platform?",
    a: "Yes. InteliHire supports unlimited team collaboration with role-based access. Invite recruiters, hiring managers, and HR administrators.",
  },
  {
    q: "What makes InteliHire different from other AI recruiting software?",
    a: "InteliHire combines AI-powered screening with automated scheduling and dynamic insights in one unified platform. Unlike tools that only handle one piece of the puzzle, we automate your entire hiring lifecycle—from job post to final hire.",
  },
  {
    q: "What kind of support do we get after implementation?",
    a: "You'll have dedicated support throughout onboarding and beyond. Our team provides training resources, technical assistance, and ongoing optimization to ensure you're getting maximum value from the platform.",
  },
  {
    q: "Does InteliHire integrate with WorkHive?",
    a: "InteliHire seamlessly integrates with WorkHive to create an end-to-end employee management ecosystem. Once InteliHire identifies and hires your perfect candidates, WorkHive takes over, handling onboarding, payroll, performance management, and ongoing HR administration.",
  },
];

  return (

    <section className="home-section-8">
       {/* FAQ */}
        <div className="faq-section">
        <div className="container">

            <h2 className="text-center">Frequently Asked Questions</h2>

            <div className="faq-list">
            {faqs.map((item, i) => (
                <div
                key={i}
                className={`faq-item ${active === i ? "active" : ""}`}
                onClick={() => setActive(active === i ? null : i)}
                >
                <div className="faq-question">
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>

                <div className="faq-answer">
                    {item.a}
                </div>
                </div>
            ))}
            </div>

        </div>
        </div>

        {/* CTA */}
        <div className="cta-section">
        <div className="container">
            <div className="cta-box text-center">

            <h2>Now Hire the Right Employees with <br/> AI Power, not ManPower</h2>

            {/* <p>
                Transform your document management with AI-powered intelligent control. Get started today.
            </p> */}

            <button className="btn btn-light">Lets Get Started</button>

            </div>
        </div>
        </div>
    </section>
  );
};

export default Section8;